import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import breakpoint from 'styled-components-breakpoint';
import DeltaIcon from 'components/atoms/callout/DeltaIcon';
import styled, { withTheme } from 'styled-components';

const Wrapper = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        height: 80%;
        padding-left: 10px;

        ${breakpoint('xs', 'md')`
            align-items: center;
            padding-left: 0px;
        `}
    `;

const CalloutDeltaIcon = styled(DeltaIcon)`
    font-size: 10px;
    align-items: flex-start;
`;

const DeltaWrapper = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        ${breakpoint('xs', 'sm')`
            flex-direction: column;
            align-items: center;
        `}
    `;

const Value = styled.div`
        font-size: 18px;
        margin-bottom: px;

        ${breakpoint('sm', 'md')`
            font-size: 15px;
        `}
        ${breakpoint('xs', 'sm')`
            font-size: 11px;
        `}
    `;

const Title = styled.div`
        font-size: 12px;
        color: ${props => props.theme.channelCallouts.colors.calloutTitle};

        ${breakpoint('xs', 'sm')`
            font-size: 8px;
            text-align: center;
        `}
    `;

const Delta = withTheme((props) => {
    if (!props.deltaVisible) {
        return null;
    }

    const calloutTheme = props.theme.callouts;
    const deltaState = props.deltaState;

    const deltaMap = {
        'normal-positive': {
            color: calloutTheme.colors.positive,
            icon: calloutTheme.icons.positive,
        },
        'normal-negative': {
            color: calloutTheme.colors.negative,
            icon: calloutTheme.icons.negative,
        },
        'invert-positive': {
            color: calloutTheme.colors.negative,
            icon: calloutTheme.icons.positive,
        },
        'invert-negative': {
            color: calloutTheme.colors.positive,
            icon: calloutTheme.icons.negative,
        },
        'normal-neutral': {
            color: calloutTheme.colors.neutral,
            icon: calloutTheme.icons.neutral,
        }
    };

    const { icon, color } = deltaMap[deltaState] || deltaMap['normal-neutral'];

    return (
        <CalloutDeltaIcon className={icon} style={{ color }} />
    );
});


class ChannelCalloutMetric extends PureComponent {
    render() {
        const { title, value, deltaState, deltaVisible } = this.props;

        return (
            <Wrapper>
                <Value>{value}</Value>
                <DeltaWrapper >
                    <Delta deltaState={deltaState} deltaVisible={deltaVisible} size={8} />
                    <Title>{title}</Title>
                </DeltaWrapper>
            </Wrapper>
        );
    }
}

ChannelCalloutMetric.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
    deltaState: PropTypes.string,
    deltaVisible: PropTypes.bool
};

export default withTheme(ChannelCalloutMetric);




// WEBPACK FOOTER //
// ./src/components/molecules/ChannelCalloutMetric.js